import type { TFunction } from "i18next";

export const renderGender = (value: string | null, t: TFunction) => {
	if (!value || !t) return "";

	switch (value) {
		case "BOYS":
		case "MALE":
			return t("male");
		case "GIRLS":
		case "FEMALE":
			return t("female");
		case "COEDS":
			return t("coed");
		default:
			return "";
	}
};
